import {createAction, props} from '@ngrx/store';
import {CmsBlock} from '../models/cms-blocks';


interface LoadSuccessCmsActionPayload {
    cmsBlocks: CmsBlock[];
}


export const loadCmsBlock = createAction(
    '[CMS] Load Block',
    props<{ blockId: string }>()
)

export const loadCmsBlocks = createAction(
    '[CMS] Load Blocks'
)

export const loadCmsBlockSuccess = createAction(
    '[CMS] Load Block Success',
    props<{ block: CmsBlock }>()
);

export const loadCmsBlocksSuccess = createAction(
    '[CMS] Load Blocks Success',
    props<LoadSuccessCmsActionPayload>()
)

export const loadCmsBlockFailure = createAction(
    '[CMS] Load Block Failure',
    props<{ blockId: string }>()
);


export const loadCmsBlocksFailure = createAction(
    '[CMS] Load Blocks Failure'
)
